import { useContext } from 'react';
import { BackendStatusContext } from './BackendStatusContext';

export function useBackendStatus() {
  const ctx = useContext(BackendStatusContext);
  if (!ctx) throw new Error('useBackendStatus must be used within BackendStatusProvider');
  return ctx;
}
